import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared/shared.module';
import { ButtonWithIndicatorModule } from '../../../button-with-indicator/button-with-indicator.module';
import { ModalWindowModule } from '../../../modal-window/modal-window.module';
import { PortalComponent } from './portal.component';
import { ReviewLevelPipe } from './review-level.pipe';
import { AgEditorToolbarModule } from '../../../ag-editor-toolbar/ag-editor-toolbar.module';

@NgModule({
  imports: [SharedModule, ModalWindowModule, ButtonWithIndicatorModule, AgEditorToolbarModule],
  declarations: [PortalComponent, ReviewLevelPipe],
  exports: [PortalComponent],
})
export class PortalModule {}
